// extracted by mini-css-extract-plugin
module.exports = {"main__title":"SecondStep_main__title__31aJM","main__table":"SecondStep_main__table__6gI1G","main":"SecondStep_main__zrcYK"};